import { Square } from 'lucide-react';

import { pluralize } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@nesso/ui/primitives/tooltip';

import { useRecordingControls, useRecordingStore } from '@/entities/audio-recording';
import { getMinSessionDurationSeconds } from '@/entities/session';
import { useConfirmDialogStore } from '@/shared/stores/confirm-dialog-store';

import { useConfirmSessionDeleteDialog } from '../../../model/use-confirm-session-delete-dialog';

export function RecordingCaptureStop() {
    const length = useRecordingStore((state) => state.length);
    const { stop, abort } = useRecordingControls();

    const openConfirmDeleteDialog = useConfirmSessionDeleteDialog();
    const openConfirmDialog = useConfirmDialogStore((state) => state.open);

    const confirmSessionDeletion = () =>
        openConfirmDeleteDialog({
            onConfirm: async () => await abort(),
        });

    const stopRecording = () => {
        if (length === 'too-short') {
            const minDuration = getMinSessionDurationSeconds();
            const secondsText = pluralize(minDuration, 'second');
            const description = `To generate a meaningful note, your sessions must be at least ${secondsText} long.`;

            openConfirmDialog({
                title: 'This session is too short',
                description,
                cancelText: 'Delete Session',
                confirmText: 'Continue Recording',
                variant: 'warning',
                onConfirm: () => {},
                onCancel: () => {
                    setTimeout(() => {
                        confirmSessionDeletion();
                    }, 0);
                },
            });
        } else {
            stop();
        }
    };

    return (
        <Tooltip delayDuration={200}>
            <TooltipTrigger asChild>
                <Button
                    variant="danger"
                    onClick={stopRecording}
                    size="lg"
                    className="px-5.5! text-base"
                >
                    <Square className="w-4 h-4" />
                    End
                </Button>
            </TooltipTrigger>
            {length === 'too-short' && (
                <TooltipContent className="w-52" side="bottom" align="start" alignOffset={1}>
                    <span className="w-52 whitespace-normal">
                        <p>We need more discussion to generate a meaningful note.</p>
                    </span>
                </TooltipContent>
            )}
        </Tooltip>
    );
}
